<template>
	<article>
		<h2>Planning</h2>

		<LoadingWrapper :loading="loading">
			<BaseCard>
				<h3>Geplande acties</h3>
				<ActionOverview
					show-headers
					:actions="actions"
					:limit="limit"
					:rie-id="rieId"
					:sortable="false"
					:company-id="companyId"
				/>

				<ButtonBar>
					<NuxtLink
						:to="actionOverviewRoute"
						class="overview-link"
					>
						Bekijk alle acties
					</NuxtLink>
				</ButtonBar>
			</BaseCard>
		</LoadingWrapper>
	</article>
</template>

<script lang="ts" setup>

	import {computed} from 'vue';
	import type {PropType} from 'vue';
	import {useRoute} from 'vue-router';
	import type {RouteLocationRaw} from 'vue-router';
	import type {ActionDecorator} from '~/lib/types/actionTypes';
	import ActionOverview from '~/components/actions/ActionOverview.vue';
	import BaseCard from '~/components/generic/BaseCard.vue';
	import {pageNames} from '~/lib/pageHelper';
	import ButtonBar from '~/components/generic/buttons/ButtonBar.vue';
	import LoadingWrapper from '~/components/generic/LoadingWrapper.vue';

	defineProps({
		actions: {
			type: Array as PropType<ActionDecorator[]>,
			required: true
		},
		limit: {
			type: Number,
			default: 5
		},
		loading: {
			type: Boolean,
			default: false
		}
	});

	const route = useRoute();
	const companyId = route.params.companyId as string;
	const rieId = route.params.rieId as string;

	const actionOverviewRoute = computed<RouteLocationRaw>(() => ({
		name: pageNames.actionOverview,
		params:
			{
				companyId,
				rieId
			}
	}));
</script>

<style scoped>
	article {
		margin: 20px 0;
	}

	h2 {
		font-size: var(--font-size-p-4);
		line-height: var(--line-height-p-4);
		font-weight: bold;
		margin: 0 0 10px;
	}

	.card {
		margin-top: 0;
		--card-border-radius: 5px;
	}

	h3 {
		font-weight: normal;
		font-size: var(--font-size-p-2);
		line-height: var(--line-height-p-2);
		grid-area: title;
		margin: 0 0 10px;
	}

	.overview-link {
		font-weight: 600;

		&:not(:hover) {
			text-decoration: none;
		}
	}
</style>
